export default {
  list: {
    title: 'Jogo',
    subtitle: 'Lista',
    add: 'Novo jogo',
    filterStatus: 'Filtro por status',
    templatePlaceholder: 'Template',
    searchPlaceholder: 'Procurar por algo...',
    tableTitle: 'Jogos Ativos',
  },
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    add: 'Novo jogo',
  },
  templateList: {
    title: 'Templates Cruzadas',
    subtitle: 'Lista',
    add: 'Novo template',
    tableTitle: 'Templates Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  templateCreate: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  templateEdit: {
    title: 'Editar',
    subtitle: 'Template',
  },
  card: {
    registration: 'Dados cadastrais',
    template: 'Template do Jogo',
    actions: 'Ações',
    publication: 'Publicação',
  },
  preview: {
    title: 'Preview do Grid:',
  },
  form: {
    template: {
      label: 'Iniciar a partir de um Template:',
      placeholder: 'Procupar templates pelo nome',
      apply: 'Aplicar Template',
      selected: 'Selecionado: {name} ({rows}x{columns})',
    },
    name: {
      label: 'Nome:',
      invalid: 'Nome é obrigatório',
    },
    prioritizeQuality: {
      label: 'Modo Alta Densidade',
      tooltip:
        'O sistema realizará múltiplas tentativas de encaixe para garantir o máximo de palavras cruzadas e evitar espaços vazios.',
    },
    avoidSimilarWords: {
      label: 'Evitar palavras similares',
      tooltip:
        'O sistema evitará palavras que possuem similaridades significativas com as palavras já presentes no grid.',
    },
    useCurrentGameReference: {
      label: 'Usar Jogo Atual como Base',
      tooltip:
        'Utiliza as posições e direções das perguntas deste jogo como gabarito ao gerar novos jogos.',
    },
    columns: 'Tamanho colunas:',
    rows: 'Tamanho linhas:',
    style: {
      label: 'Estilo do jogo:',
      default: 'Padrão',
      radius: 'Arredondado',
      times: 'Font Times',
    },
    questionColor: 'Cor da questão:',
    font: 'Fonte:',
    level: {
      label: 'Nível:',
      placeholder: 'Selecione um nível',
      easy: 'Fácil',
      medium: 'Médio',
      hard: 'Difícil',
    },
    copyLayout: {
      label: 'Copiar Layout do Jogo:',
      placeholder: 'Selecione um jogo base...',
    },
    bank: {
      title: 'Banco de respostas',
      count: 'Quantidade:',
      label: 'Banco:',
    },
    hint: 'Dê duplo clique nas células para marcar como pergunta',
  },
  sidebar: {
    createdAt: 'Criado em:',
    updatedAt: 'Atualizado em:',
    setDraft: 'Mudar para Rascunho',
    setCompleted: 'Finalizar Jogo',
    exportHint: 'Você precisa salvar antes de exportar.',
    importFile: 'Importar Arquivo',
    saveAsTemplate: 'Salvar como Template',
    saveAndGenerate: 'Salvar e Gerar novo Jogo',
    emptyGridHint: 'O grid está sem palavras. Insira novas para habilitar.',
    fillWords: 'Inserir Palavras',
    noQuestionsHint: 'Sinalize pelo menos uma pergunta no grid.',
  },
  templatePage: {
    clearTemplate: 'Limpar Template',
  },
  option: {
    answer: 'Resposta',
    question: 'Pergunta',
    merge: 'Mesclar',
    split: 'Dividir',
    arrows: 'Setas',
    clearCell: 'Apagar célula',
  },
  answerModal: {
    direction: 'Direção',
    directionHint: 'a partir da primeira letra',
    directionPlaceholder: 'Selecione qual a direção de preenchimento',
  },
  questionModal: {
    noQuestions: 'Esta resposta não possui perguntas cadastradas!',
    textSize: 'Tamanho do texto',
    textSizePlaceholder: 'Selecione um tamanho',
    fontSize: 'Tamanho da fonte',
    fontSizePlaceholder: 'Selecione o tamanho da fonte',
    required: 'Campo obrigatório',
    registeredQuestions: 'Perguntas cadastradas',
    levelTooltipTitle: 'Níveis de dificuldade:',
    level: 'Nível',
    levelPlaceholder: 'Selecione o nível...',
    levelInvalid: 'Nível é obrigatório',
    question: 'Pergunta',
    answerLabel: '( Resposta: {answer} )',
    questionInvalid: 'Pergunta é obrigatória',
    deleteTitle: 'Excluir Pergunta',
    deleteMessage: 'Tem certeza que deseja excluir esta pergunta do sistema?',
  },
  editQuestionModal: {
    title: 'Editar pergunta',
    question: 'Pergunta:',
    questionInvalid: 'Pergunta é obrigatória',
    level: 'Nível:',
    levelPlaceholder: 'Selecione o nível...',
    levelInvalid: 'Nível é obrigatório',
    warning:
      'As alterações serão refletidas no banco de palavras e não apenas neste puzzle.',
  },
  arrowsModal: {
    position: 'Posição',
    positionPlaceholder: 'Selecione a posição',
    direction: 'Direção',
    directionPlaceholder: 'Selecione qual a direção de preenchimento',
  },
  ungroupModal: {
    size: 'Tamanho',
    sizePlaceholder: 'Selecione o tamanho',
  },
  split: {
    third: '1/3 da linha',
    half: '1/2 da linha',
    twoThird: '2/3 da linha',
    twoColumns: '2 colunas',
  },
  saveTemplateModal: {
    title: 'Salvar como Template',
    name: 'Nome:',
    placeholder: 'Ex: Grid Fácil - 15x15',
    hint: 'Este template guardará apenas a posição das perguntas para ser reutilizado depois.',
    save: 'Salvar Template',
  },
  importModal: {
    title: 'Importar Arquivo (.txt)',
    howToFormat: 'Como formatar o arquivo?',
    followModel: 'Siga o modelo abaixo para o grid ser gerado corretamente:',
    letters: 'Letras (A-Z): Células preenchidas.',
    dots: 'Ponto (.): Células vazias.',
    size: 'Tamanho: Todas as linhas devem ter a mesma quantidade de caracteres.',
    downloadExample: 'Baixar modelo .txt',
    confirm: 'Confirmar Importação',
    invalidFormat: 'O formato do arquivo deve ser .txt',
    invalidChars:
      'Arquivo inválido! Use apenas letras (A-Z) e pontos (.) para células vazias.',
    invalidRows: 'Arquivo inválido: as linhas possuem tamanhos diferentes.',
  },
  unsavedModal: {
    title: 'Alterações não salvas',
    message: 'Há alterações não salvas. Deseja continuar sem salvar?',
    continue: 'Continuar',
  },
  confirm: {
    title: 'Confirmação',
    message: 'Tem certeza que deseja continuar?',
    applyTemplateTitle: 'Confirmar Mudança',
    applyTemplateMessage:
      'Deseja carregar o grid de "{name}"? Isso substituirá suas linhas e colunas atuais.',
    saveAsTemplateTitle: 'Criar Novo Template',
    saveAsTemplateMessage:
      'Deseja salvar a estrutura atual (posições das perguntas) como um novo template? As letras atuais serão limpas no template salvo.',
    overwriteAnswer:
      'Há uma resposta nesta direção, tem certeza que deseja continuar?',
    finalizeTitle: 'Finalizar jogo',
    finalizeMessage:
      'Este jogo será finalizado e não poderá mais ser editado. Deseja continuar?',
    finalize: 'Finalizar',
  },
  alert: {
    sendSuccess: 'Enviado com sucesso',
    sendError: 'Erro ao enviar. Tente novamente.',
    statusBatchUpdated: 'Status dos Jogos atualizados com sucesso!',
    statusBatchUpdatedWithSkipped:
      'Status atualizado com sucesso! {skipped} jogo(s) já finalizado(s) foram ignorados.',
    layoutImported: 'Layout e coordenadas das dicas importados com sucesso!',
    templateApplied: 'Template aplicado com sucesso!',
    requestCancelled: 'Solicitação cancelada pelo usuário',
    fillAnswerFailed: 'Não foi possível preencher a resposta',
    bankNotEnough:
      'Não há {count} respostas únicas disponíveis com mais de 3 letras nesse jogo.',
    mergeMergedCell: 'Não é possivel mesclar uma outra célula mesclada',
    mergeDirectionOnly:
      'Só é possivel mesclar células na horizontal ou vertical',
    templateSavedSelected: 'Template salvo e selecionado para uso!',
    templateCleared:
      'O template foi limpo: todas as marcações de questão foram removidas',
    generateVariationFailed:
      'Não foi possível gerar uma nova variação do jogo.',
    cannotSaveWithBaseLayout:
      'Não é possível salvar e gerar variação enquanto um Layout Base estiver importado. Preencha as palavras primeiro ou limpe o layout.',
    saveAsTemplateFirst:
      'Salve este jogo como template antes de gerar novos jogos.',
    savedLoadingVariation: 'Jogo salvo! Carregando a nova variação gerada...',
    savedButVariationFailed:
      'O jogo foi salvo, mas não foi possível gerar uma nova variação. Tente novamente.',
    gameSaved: 'Jogo salvo com sucesso!',
    statusUpdated: 'Status atualizado com sucesso!',
    templateSaved: 'Template salvo com sucesso!',
    questionDeleted: 'Pergunta deletada com sucesso!',
    questionUpdated: 'Pergunta atualizada com sucesso!',
    wordTooLong: 'Palavra grande demais',
    readOnly: 'Este jogo já foi finalizado e não pode mais ser editado.',
  },
};
